import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '../services/session.service';

@Pipe({
    name: 'getLink',
    standalone: true
})
export class GetLinkPipe implements PipeTransform {

	constructor(private session: SessionService) {}

	transform(path: Array<string | number> = []): Array<string | number> {
		return this.session.getLink(path);
	}
}
